<template>
  <div class="titulo-container">
    <div class="linha-container">
      <div></div>
    </div>
    <h2 v-if="titulo">{{ titulo }}</h2>
    <div class="linha-container">
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CenarioTitulo",
  props: {
    titulo: String
  }
};
</script>

<style lang="scss" scoped>
.titulo-container {
  display: flex;
  margin: 0;
  h2 {
    font-family: "Open Sans";
    font-weight: bold;
    text-align: center;
    font-size: 13px;
    color: #9ea2a7;
    margin: 0 1rem;
  }

}
.linha-container {
  display: flex;
  height: 100%;
  width: 100%;
  div {
    height: 8px;
    width: 100%;
    border-bottom: 1px solid #9ea2a7;
  }
}
</style>
